module.exports = __webpack_public_path__ + "static/media/Nasus.b522ca7c.png";